__turbopack_context__.v({
  "active": "index-module-scss-module__b_Lu8W__active",
  "icon-container": "index-module-scss-module__b_Lu8W__icon-container",
  "nav-bottom": "index-module-scss-module__b_Lu8W__nav-bottom",
});
